export default __webpack_public_path__ + "static/media/video-1.714461da.mp4";